import React from 'react';
import { useStateSelector, accountIdSelector } from '../../data/global/dataSelectors';
import { useAccountApi } from '../../context/Api';
import { useDispatcher } from '../../data/global/hooks';
import { ActivitySummaryTable } from './components/ActivitySummaryTable';
import useMount from 'react-use/lib/useMount';
import _ from 'lodash';
import { ActivitySummaryTotals } from './ActivitySummaryTotals';
import { useSharedPLCalculations } from '../../hooks/useSharedPLCalculations';
import { SignedNumber } from '@tradingblock/components';
import { useQuoteActions, useQuoteSymbolSubscriptionFromGlobalState } from '../../hooks/useQuoteData';
import { getPositionAndOrderSymbols } from '../../data/global/selectors/orderSelector';

const ActivitySummaryView: React.FunctionComponent<{}> = () => {
  const { totals } = useSharedPLCalculations();
  return (
    <>
      {/* <TimeframeContainer /> */}
      <div style={{ paddingBottom: '10px' }} className="block-section-fixed">
        <div className="row justify-content-between">
          <div className="col-auto">
            Symbols traded <strong>today</strong>: Daily P/L
            <SignedNumber value={totals.tradedToday.total} format currency hideIcon />
          </div>
          <div className="col-auto align-self-end">
            <ActivitySummaryTotals />
          </div>
        </div>
      </div>

      <ActivitySummaryTable />
    </>
  );
};

export const ActivitySummary: React.FunctionComponent<{}> = () => {
  const { setQuotes, setSpreads } = useQuoteActions();
  setQuotes([]);
  setSpreads([]);
  useQuoteSymbolSubscriptionFromGlobalState(getPositionAndOrderSymbols);

  useMount(() => {
    //loadPnL(api, dispatcher)(currId as number, { accountId: currId as number });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });
  return <ActivitySummaryView />;
};
